import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as SockJS from 'sockjs-client';
import * as Stomp from 'stompjs';
import { AppModule } from '../app.module';

@Injectable({
    providedIn: 'root',
})
export class StompService {
    private connecting: boolean = false;
    private topicQueue: any[] = [];

    constructor(private app:AppModule) {
       }

       socket = new SockJS(this.app.host + 'sba-websocket');
       stompClient = Stomp.over(this.socket);

       //stompClient = Stomp.over(() => new SockJS(this.app.host + 'sba-websocket'));

    subscribe(topic: string, callback: any): void {

        this.socket = new SockJS(this.app.host + 'sba-websocket');
        this.stompClient = Stomp.over(this.socket);


        this.connecting = false;

        // If stomp client is currently connecting add the topic to the queue
        if (this.connecting) {
            this.topicQueue.push({
                topic,
                callback
            });
            return;
        }

        const connected: boolean = this.stompClient.connected;
        if (connected) {
            // Once we are connected set connecting flag to false
            this.connecting = false;
            this.subscribeToTopic(topic, callback);
            return;
        }

        // If stomp client is not connected connect and subscribe to topic
        this.connecting = true;
        this.stompClient.connect({}, (): any => {
            this.subscribeToTopic(topic, callback);

            // Once we are connected loop the queue and subscribe to remaining topics from it
            this.topicQueue.forEach((item:any) => {
                this.subscribeToTopic(item.topic, item.callback);
            })

            // Once done empty the queue
            this.topicQueue = [];
        });
    }

    private subscribeToTopic(topic: string, callback: any): void {
        setTimeout(():any =>{
            this.stompClient.subscribe(topic, (response?:string): any => {
                callback(response);
            },{ id: "myTopicId"});
        }, 3000);

    }

    unSubscribeToTopic(): void {
        this.stompClient.unsubscribe("myTopicId");
        this.connecting = false;
        //this.stompClient.disconnect;
        //this.stompClient.unsubscribe("sub-1");
       // this.stompClient.unsubscribe("sub-2");
       // this.stompClient.disconnect();
    }
}